if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');
      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      document.addEventListener('DOMContentLoaded', this.setTransparentClass.bind(this));

      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
          window.dispatchEvent(new Event('scroll'));
        } else {
          this.classList.add('is-sticky');
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
 
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
        document.querySelector('.product-information')?.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }

    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
    setTransparentClass() {
      this.template_header = document.querySelector('.template-header');

      if (this.template_header && this.template_header.classList.contains('template-header--has-image-true') && this.template_header.dataset.sectionIndex == 1) {
        this.classList.remove('transparent--false');
        this.classList.add('transparent--true');
      }
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.buttons = this.querySelectorAll('.full-menu--link-parent');
      this.header = this.closest('.header');
      this.subButtons = this.querySelectorAll('.full-menu--link-child');
      this.panel = this.querySelector('.full-menu--panel');
      this.panel1 = this.querySelector('.full-menu--panel--level-1');
      this.panel2 = this.querySelector('.full-menu--panel--level-2');
      this.cc = this.querySelector('.full-menu--cc');
      this.toggle = this.querySelector('.full-menu--toggle');
      this.panelWidth = 320;
    }
    connectedCallback() {
      this.buttons.forEach((button, i) => {
        button.addEventListener('mouseenter', (e) => this.onParentHover(button, e, i));
        button.addEventListener('keydown', (e) => this.onParentKeydown(button, e, i));
        button.addEventListener('focus', (e) => this.onParentFocus(button, e, i));
      });
      this.subButtons.forEach((button, i) => {
        button.addEventListener('mouseenter', (e) => this.onChildHover(button, e, i));
      });
      this.panel2.addEventListener('mouseleave', this.onPanelLeave.bind(this));
      this.toggle.addEventListener('click', this.onToggleClick.bind(this));
      this.cc.addEventListener('mousemove', this.onCC.bind(this));

      this.addEventListener('blur', this.onCC.bind(this));
      document.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.onCC();
        }
      });
    }
    onParentFocus() {
      this.header.classList.add('open-menu');
    }
    onParentKeydown(button, e, i) {
      if (e.code.toUpperCase() !== 'ENTER') return;

      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel1.querySelectorAll('.full-menu--subpanel'),
          target_selector = button.dataset.target;
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');

        [].forEach.call(submenus, function (el) {
          el.classList.remove('active');
        });
        this.panel1.querySelector(target_selector).classList.add('active');
        this.panel1.querySelector(target_selector).querySelectorAll('a')[0].focus();
      }
    }
    onParentHover(button, e, i) {
      this.header.classList.add('open-menu');

      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel1.querySelectorAll('.full-menu--subpanel'),
          target_selector = button.dataset.target;
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');

        [].forEach.call(submenus, function (el) {
          el.classList.remove('active');
        });
        this.panel1.querySelector(target_selector).classList.add('active');
      } else {
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 1) + 'px');
      }
      window.dispatchEvent(new Event('resize'));
      e.preventDefault();
    }
    onChildHover(button, e, i) {
      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel2.querySelectorAll('.full-menu--subpanel'),
          target_selector = button.dataset.target;

        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 3) + 'px');
        [].forEach.call(submenus, function (el) {
          el.classList.remove('active');
        });
        this.panel2.querySelector(target_selector).classList.add('active');
      } else {
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');
      }

      e.preventDefault();
    }
    onPanelLeave() {
      this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');
    }
    onToggleClick() {
      this.header.classList.add('open-menu');
    }
    onCC() {
      this.panel.style.setProperty('--menu-panel-width', (this.panelWidth) + 'px');
      [].forEach.call(this.panel, function (el) {
        el.classList.remove('active');
      });
      this.header.classList.remove('open-menu');
    }
  }
  customElements.define('full-menu', FullMenu);
}